var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalaoConversa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.55558C17.0031 9.7288 16.729 10.8861 16.2 11.9334C14.9209 14.4928 12.3057 16.11 9.44445 16.1111C8.27123 16.1142 7.11388 15.8401 6.06667 15.3111L1 17L2.68889 11.9334C2.15994 10.8861 1.88583 9.7288 1.88889 8.55558C1.89 5.69433 3.50726 3.07917 6.06667 1.80003C7.11388 1.27108 8.27123 0.996966 9.44445 1.00003H9.88889C13.7252 1.21167 16.7884 4.27486 17 8.11114V8.55558V8.55558Z",
    stroke: "#77838F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalaoConversa);
export default __webpack_public_path__ + "static/media/BalaoConversa.393105a6e27154f66d5584d4465ac866.svg";
export { ForwardRef as ReactComponent };